module.exports = __webpack_public_path__ + "img/dropdown_active.0390c47e.svg";